import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { Container } from 'reactstrap';
import { getSession, refreshSession } from '../actions/sessionsActions';
import getVenueAreas from '../actions/venueAreasActions';
import setFilter from '../actions/filterActions';
import HeaderContainerTemplate from '../containers/templates/HeaderContainerTemplate';
import QuickBookingSessions from '../containers/QuickBookingSessions';
import SessionSlotCard from '../components/SessionSlotCard';
import i18n from '../utils/i18n';
import { setPendingBookingSessionEventId } from '../actions/pendingBookingActions';
import SelectAreaComponent from '../components/SelectAreaComponent';
import routeConstants from '../utils/routeConstants';
import { filterConstants } from '../utils/types';
import { idsNames } from '../utils/constants';
import { resetScrollToId } from '../actions/scrollToActions';

import './styles/SingleSessionScreen.scss';

class SingleSession extends React.Component {
  componentDidMount() {
    this.props.refreshSession(this.props.match.params.id);
  }

  componentWillUnmount() {
    this.props.setPendingBookingSessionEventId(null);
    this.props.resetScrollToId();
  }

  render() {
    const availableAreas = this.props.availableAreas || [];
    const sessionEventsEmpty = this.props.session && this.props.session.events.length === 0;

    return (
      <HeaderContainerTemplate>
        {!this.props.sessionLoading &&
          this.props.session && (
          <div className="session-top-image">
            <img
              src={
                this.props.session.picture &&
                  decodeURIComponent(this.props.session.picture)
              }
              alt=""
            />
          </div>
        )}
        <Container>
          {!this.props.sessionLoading && (
            <SelectAreaComponent
              availableAreas={ availableAreas }
              selectedValue={ this.props.areaFilterValue }
              notifyChange={ areaId => {
                this.props.setAreaFilter(areaId);
                this.props.getSession(this.props.match.params.id, areaId);
              } }
            />
          )}
        </Container>
        <Container className="session-content">
          {this.props.sessionLoading && (
            <div className="fetching">
              {i18n.t('FETCHING_SESSION')}
            </div>
          )}
          {!this.props.sessionLoading &&
            this.props.session && (
            <div className="session-data">
              <div className="session-info">
                <div className="session-text">
                  <div className="session-name">
                    {this.props.session.name}
                  </div>
                  <div className="session-subname">
                    {this.props.session.sub_name}
                  </div>
                  <div className="session-description">
                    {this.props.session.description}
                  </div>
                </div>
              </div>
              <div className="session-events">
                <div className="cards">
                  {this.props.session.events.map(event => (
                    <div
                      className="card-wrapper event-card-wrapper"
                      key={ event.id }
                      id={ `${idsNames.SESSION_ID_PREFIX}${event.id}` }
                    >
                      <QuickBookingSessions
                        event={ event }
                        backRoute={ routeConstants.SINGLE_SESSION_ROUTE(
                          this.props.match.params.id
                        ) }
                        refreshAction={ refreshSession(
                          this.props.match.params.id
                        ) }
                      >
                        <SessionSlotCard event={ event } />
                      </QuickBookingSessions>
                    </div>
                  ))}
                  {sessionEventsEmpty &&
                    <div className="no-data-with-criteria">
                      {i18n.t('sessionsScreen.NO_SESSIONS_MATCH_YOUR_CRITERIA')}
                    </div>
                  }
                </div>
              </div>
            </div>
          )}
        </Container>
      </HeaderContainerTemplate>
    );
  }
}

SingleSession.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      id: PropTypes.string
    })
  }).isRequired,
  getSession: PropTypes.func.isRequired,
  setAreaFilter: PropTypes.func.isRequired,
  session: PropTypes.shape({
    id: PropTypes.number,
    logo: PropTypes.string,
    name: PropTypes.string,
    sub_name: PropTypes.string,
    description: PropTypes.string,
    picture: PropTypes.string,
    events: PropTypes.PropTypes.arrayOf(PropTypes.shape({}))
  }),
  sessionLoading: PropTypes.bool,
  setPendingBookingSessionEventId: PropTypes.func.isRequired,
  availableAreas: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number,
      name: PropTypes.string,
      description: PropTypes.string
    })
  ),
  areaFilterValue: PropTypes.number,
  refreshSession: PropTypes.func.isRequired,
  resetScrollToId: PropTypes.func.isRequired
};

SingleSession.defaultProps = {
  session: {
    id: 0,
    logo: '',
    name: '',
    sub_name: '',
    description: '',
    picture: '',
    events: []
  },
  sessionLoading: false,
  availableAreas: [],
  areaFilterValue: null
};

const mapStateToProps = state => ({
  session: state.singleSession.data,
  sessionLoading: state.singleSession.loading,
  pendingBookingEventId: state.pendingBooking.sessionEventId,
  availableAreas: state.venueAreas.data,
  areaFilterValue: state.filter[filterConstants.AREA_FILTER]
});

const mapDispatchToProps = dispatch => ({
  dispatch,
  setPendingBookingSessionEventId: eventId =>
    dispatch(setPendingBookingSessionEventId(eventId)),
  getSession: (sessionId, areaId) => dispatch(getSession(sessionId, areaId)),
  setAreaFilter: areaId =>
    dispatch(setFilter(filterConstants.AREA_FILTER, areaId)),
  getVenueAreas: () => dispatch(getVenueAreas()),
  refreshSession: id => dispatch(refreshSession(id)),
  resetScrollToId: () => dispatch(resetScrollToId())
});

export default connect(mapStateToProps, mapDispatchToProps)(SingleSession);



// WEBPACK FOOTER //
// ./src/scenes/SingleSession.js